<template>
  <section>
    <slide-transition>
      <router-view name="stakeholderSearchWrapper"/>
    </slide-transition>

    <slide-transition>
      <keep-alive>
        <router-view/>
      </keep-alive>
    </slide-transition>
    <slot />
  </section>
</template>

<script>
import SlideTransition from "Assets/js/transitions/whodoyouknow/SlideTransition.vue";

export default {
  name: "ActionSection",
  components: {
    SlideTransition
  }
};
</script>
